import { PaymentAgreementListModel, PaymentAgreenentModel } from '../../../common/src';
import * as backendApi from '../shared/backend-api';
export default class PaymentAgreementService {
  constructor() {}

  getPersonActiveValidPaymentsAgreement(
    selectedUserId: number,
    selectedUserCenterId: number,
    includeInvalid = false
  ): Promise<PaymentAgreementListModel> {
    return backendApi.post('payment-agreement/get-person-active-valid-payments-agreements', {
      selectedUserId,
      selectedUserCenterId,
      includeInvalid,
    });
  }
}
